
export default {
	name: 'NewsMarquee',
	props: {
		backFilter:  { type: String,  default: 'blur(20px)' },
		background:  { type: String,  default: 'rgba(255, 255, 255, 0.1)' },
		duration:    { type: [Number, String], default: 5 }, // Seconds per News
		height:      { type: [Number, String], default: 32 },
		newsLines:   { type: Array,   default: null }, // Array<{ icon: string, coin: string, text: string, price: number, change: number }>
		priceFormat: { type: String,  default: '${#}' },
	},
	data () {
		return {
			INCREASE_ARROW:
			`<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M9.5 3.5H13.5V7.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
				<path d="M13.5 3.5L7.85 9.15C7.75654 9.24161 7.63088 9.29293 7.5 9.29293C7.36912 9.29293 7.24346 9.24161 7.15 9.15L4.85 6.85C4.75654 6.75839 4.63088 6.70707 4.5 6.70707C4.36912 6.70707 4.24346 6.75839 4.15 6.85L0.5 10.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
			</svg>`,
			DECREASE_ARROW:
			`<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M9.5 10.5H13.5V6.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
				<path d="M13.5 10.5L7.85 4.85C7.75654 4.75839 7.63088 4.70707 7.5 4.70707C7.36912 4.70707 7.24346 4.75839 7.15 4.85L4.85 7.15C4.75654 7.24161 4.63088 7.29293 4.5 7.29293C4.36912 7.29293 4.24346 7.24161 4.15 7.15L0.5 3.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
			</svg>`,
			STABLE_ARROW:
			`<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M1.24707 7.125L12.7415 7.14457M12.7415 7.14457L11.2298 8.59266M12.7415 7.14457L11.3016 5.68464" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
			</svg>`,
		};
	},
	computed: {
		styles ()
		{
			return {
				'--news-marquee--incr-color': '#4ade80',
				'--news-marquee--decr-color': '#f87171',
				'--news-marquee--stab-color': '#60a5fa',
				'--news-marquee--bg': this.background,
				'--news-marquee--filter': this.backFilter,
				'--news-marquee--height': this.cssLength(this.height),
			};
		},
	},
	methods: {
		cssLength (value)
		{
			if(typeof value == 'number') return value + 'px';
			if(typeof value == 'string'){
				if(/^\d+$/.test(value)) return value + 'px';
				return value;
			}
			return null;
		},
		formatNumber (num, fix, sign)
		{
			if(typeof fix != 'number' || fix < 0) fix = -1;
			const signed = Math.sign(num);
			num = Math.abs(num);
			const parts = String(num).split('.');
			const decimal = Number(parts[0]).toLocaleString('en');
			const fraction = (parts.length == 2 && fix != 0 ? (fix > 0 ? Number('0.' + parts[1]).toFixed(fix).substring(1) : '.' + parts[1]) : '');
			return (signed > 0 ? (sign ? '+' : '') : signed < 0 ? '−' : '') + decimal + fraction;
		},
		changeDir (rowChange)
		{
			if(rowChange > 0) return 'increase';
			if(rowChange < 0) return 'decrease';
			return 'stable';
		},
		prepareIcon (row)
		{
			if(typeof row.icon == 'string' && row.icon.trim()){
				if(/^(?:https?|ftps?|file|data):/.test(row.icon)) return `<img role="icon" src="${row.icon}" />`;
				if(row.icon.length <= 4) return `<span role="emoji">${row.icon}</span>`;
			}
			return '';
		},
		preapreText (row)
		{
			return row.text
			.replace(/\s+/g, (m) => `<span role="space" style="--len:${m.length}"></span>`)
			.replace(/\{([^}]+)\}/g, (mch, $1) => {
				switch($1){
					case 'ARROW':  return '<span role="arrow">' + (row.change > 0 ? this.INCREASE_ARROW : row.change < 0 ? this.DECREASE_ARROW : this.STABLE_ARROW) + '</span>';
					case 'ICON':   return this.prepareIcon(row);
					case 'COIN':   return '<span role="coin">' + row.coin + '</span>';
					case 'CHANGE': return '<span role="change">' + this.formatNumber(row.change, 2, true) + '%</span>';
					case 'PRICE':  return '<span role="price">' + this.priceFormat.replace(/\{#\}/g, this.formatNumber(row.price)) + '</span>';
				}
				return mch;
			});
		},
	},
}
